import type { ValueTransformer } from '@/hooks/invoice_reports/useShowSearchValue';
import { BaseOption } from '@/hooks/useTypeToOptions';
import { useCallback, useMemo } from 'react';

export const usePaymentMethodTransformer = (
  paymentMethodOptions: BaseOption[]
) => {
  const paymentMethodTransformer: ValueTransformer = useCallback(
    (value) =>
      typeof value === 'string'
        ? paymentMethodOptions.find((opt) => String(opt.value) === value)
            ?.label ?? value
        : '',
    [paymentMethodOptions]
  );

  return useMemo(
    () => ({ payment_method: paymentMethodTransformer }),
    [paymentMethodTransformer]
  );
};
